import { useTranslation } from 'react-i18next'

import {
  generateRequestSummary,
  getRequestSummaryTaskStatus,
} from '../../../../api'
import { ProfileAISummaryWidget } from '../../../Widget'
import { useRequestProfileContext } from '../../RequestProfile.hooks'
import { RequestProfileWidgetKey } from '../RequestProfileWidget.constants'

import * as styles from './RequestProfileWidgetAISummary.module.css'

function RequestProfileWidgetAISummary({
  className = styles.aiSummaryWidget,
  isSkeleton,
  requestData,
}) {
  const { t } = useTranslation()

  const { patchRequestSummaryData, requestSummaryData } =
    useRequestProfileContext()

  const requestId = requestData?.id

  return (
    <ProfileAISummaryWidget
      className={className}
      contentContainerProps={{
        className: styles.aiSummaryContent,
      }}
      data={requestSummaryData}
      generateSummaryParams={{ request_id: requestId }}
      initiallyExpanded={false}
      isSkeleton={isSkeleton || !requestSummaryData}
      key={requestId}
      qaName={RequestProfileWidgetKey.AI_SUMMARY}
      textProps={{
        warningText: t('Common.ProfileWidgetAISummaryWarningTextKey'),
      }}
      onError={patchRequestSummaryData}
      onGenerateSummary={generateRequestSummary}
      onGetTaskStatus={getRequestSummaryTaskStatus}
      onSuccess={patchRequestSummaryData}
    />
  )
}

export default RequestProfileWidgetAISummary
